var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.configuracion)?[_c('LoadCssComponent',{attrs:{"estilos":_vm.configuracion.css_front}})]:_vm._e(),(_vm.manager.tipo == 1)?[_c('LayoutSports')]:_vm._e(),(_vm.manager.tipo == 2)?[_c('LayoutTeatros')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }